import { ReactNode } from 'react'
import { Box } from '@mui/material'
import SimpleBar from 'simplebar-react'
import 'simplebar-react/dist/simplebar.min.css'

type Props = {
    children: ReactNode
    /** Optional id on the scrollable node (for scroll-linked children). */
    scrollId?: string
}

/** Fills the remaining panel height and scrolls, the same way the AI tab does. */
const SupportScrollArea = ({ children, scrollId }: Props) => (
    <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <SimpleBar style={{ flex: 1, maxHeight: '100%' }} scrollableNodeProps={scrollId ? { id: scrollId } : undefined}>
            {children}
        </SimpleBar>
    </Box>
)

export default SupportScrollArea
